//File to display Project management dashboard page
//Fetch Modulewise count and display in Bar Chart
//Fetch current week task details and display in timeline chart

import React, { useState, useEffect } from 'react';
import { Box, Button, Tooltip, Typography, } from '@mui/material';
import axios from 'axios';
import { Stack, Grid, Paper } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import EditIcon from "@mui/icons-material/Edit";
import { useSelector } from 'react-redux';
import IconButton from "@mui/material/IconButton";
import { RootState } from '../../store';
import { useNavigate, useLocation } from "react-router-dom";
import ProjectWeeklyTasks from './ProjectCalendar';
import { BASEURL } from "../../constants/Common";
import getTheme from '../../theme/theme';
import { ThemeProvider } from '@mui/material';
import { Projects } from './ProjectInterfaces';
import { Backdrop, CircularProgress, } from "@mui/material";
import FloatingButton from '../../pages/usersupport/helpdesk/FloatingButton';
import { OrganizationFinal } from '../../pages/subscriptionplans/Subscription';
import { toast } from 'react-toastify';

const ProjectManagementPage = (): JSX.Element => {
  const [projectStatus, setProjectStatus] = useState<Array<any>>([]);
  const [projectCount, setProjectCount] = useState(1);
  const [modulesName, setModulesName] = useState<Array<any>>(['']);
  const [modulesCount, setModulesCount] = useState<Array<number>>([0]);
  const navigate = useNavigate();
  const theme = getTheme();
  const [organizationFinal, setOrganizationFinal] = useState<OrganizationFinal | null>(null);

  // const [projectDetails, setProjectDetails] = useState<Projects>({
  //   id: null,
  //   organization_id: '', user_id: '',
  //   project_name: '', project_code: '',
  //   created_on: '',
  //   project_type: '', project_status: '',
  //   project_start_date: '', project_end_date: '',
  //   project_manager: ''
  // });

  const [projectData, setProjectData] = useState<Projects>();
  const [selProjectId, setSelProjectId] = useState<number>(0);
  //const [selectedProject, setSelectedProject] = useState<Projects | null>(null);
  const selectedProjectTitle = useSelector((state: RootState) => state.project.selectedProjectTitle);
  const [isLoading, setIsLoading] = useState(true); // Initially set to true
  const location = useLocation();
  let orgid = localStorage.getItem('orgid');  //get org id from user table
  const userid = localStorage.getItem('userid');
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Called when navigate through left menu bar
        let argProjectData = location?.state?.data;
        let l_selectedProjectId = 0;
        if(argProjectData)
           l_selectedProjectId = argProjectData?.id || 0;
        else
           l_selectedProjectId = selectedProjectTitle.length !== 0 ? parseInt(selectedProjectTitle) : 0;

        setSelProjectId(l_selectedProjectId);

        await fetchOrganization();
        await fetchModuleDetails(l_selectedProjectId);
        if (l_selectedProjectId !== 0) {
          await fetchProjectDetails(l_selectedProjectId);
        } else {
          await fetchProjectStatus();
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();

  }, [location, setSelProjectId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // On project name is changed in the project list in top bar, update chart and details
        let l_selectedProjectId = selectedProjectTitle.length !== 0 ? parseInt(selectedProjectTitle) : 0;
        setSelProjectId(l_selectedProjectId);

        setIsLoading(true);

        await fetchModuleDetails(l_selectedProjectId);
        if (l_selectedProjectId === 0) {
          await fetchProjectStatus();
        } else {
          await fetchProjectDetails(l_selectedProjectId);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();

  }, [selectedProjectTitle]);

  // const fetchOrganization = async () => {
  //   try {
  //     const response = await axios.get(`${BASEURL}/organization/${orgid}/`, {
  //       headers: { Accept: 'application/json' },
  //     });
  //     setOrganizationFinal(response.data);
  //   } catch (error) {
  //     console.error('Error fetching organization:', error);
  //   }
  // };

  const fetchOrganization = async () => {
    try {
      const response = await axios.get(`${BASEURL}/organization/${orgid}/`, {
        headers: { Accept: 'application/json' },
      });
      setOrganizationFinal(response.data);
      const subscriptionStatus = response.data.organization?.organization_subscription_status;
      localStorage.setItem('subscriptionstatus', subscriptionStatus)
    } catch (error) {
      console.error('Error fetching organization:', error);
    }
  };

  const fetchProjectStatus = async () => {
    try {
      const status_url = `${BASEURL}/projects/status/?orgid=${orgid}&userid=${userid}`;
      const response = await axios.get(status_url, {
        headers: { Accept: 'application/json' },
      });
      const project_stat = response.data.projects.filter(
        (project: any) => project.project_status.project_status !== 'Deleted'
      );
      setProjectStatus(project_stat);

      // Calculate the sum of counts using the reduce method
      const sumOfCounts = project_stat.reduce((total: any, item: any) => total + item.project_status.count, 0);
      setProjectCount(sumOfCounts);
    } catch (error) {
      console.log(error);
    }
  };

// useEffect(()=>{
//   fetchOrganization()
// },[])
  

  const fetchProjectDetails = async (arg_selected_id: any) => {
    try {
      const projdetails_url = `${BASEURL}/projects/${arg_selected_id}/?orgid=${orgid}&userid=${userid}`;
      const response = await axios.get(projdetails_url, {
        headers: { Accept: 'application/json' },
      });
      const project_det = response.data.projects[0];
      setProjectData(project_det);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchModuleDetails = async (arg_selected_id: any) => {
    try {
      const module_url = `${BASEURL}/projects/modules/${arg_selected_id}/?orgid=${orgid}&userid=${userid}`;
      const response = await axios.get(module_url, {
        headers: { Accept: 'application/json' },
      });
      const modulesData = response.data.module_detail.modules;
      const modules = Object.keys(modulesData).map(module => ({
        module: module,
        count: modulesData[module]
      }));
      const moduleNamesArray = modules.map(item => item.module);
      const countsArray = modules.map(item => item.count);
      setModulesName(moduleNamesArray);
      setModulesCount(countsArray);
    } catch (error) {
      console.log("Error in fetching module details" + error);
    }
  };

  const formatDate = (dateString: any): string => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Adding 1 because month is zero-indexed
    const day = String(date.getDate()).padStart(2, '0');
    return `${day}-${month}-${year}`;
  };

  const handleCreateProject = () => {
    if (maxprojectsallowed !== undefined && projectCount > maxprojectsallowed) {
      toast.error('You have reached the maximum number of projects creation. Please upgrade.');
      return;
    }
    navigate('/createproject');
  };

  const handleEditProject = () => {
    navigate('/createproject', { state: { data: projectData } });
  };

  const subscriptionstatus = organizationFinal?.organization?.organization_subscription_status;
  const isuseradmin = JSON.parse("" + localStorage.getItem('userRoleAdmin')) === 'Admin';
  const userraccess = JSON.parse("" + localStorage.getItem('userrole'));
  const projectAccess = userraccess?.projectaccess === 'Owner';
  const EditAccess = userraccess?.projectaccess === 'Edit';
  const maxprojectsallowed: number | undefined = organizationFinal?.subscription_plan?.projects;
  const iscreateButtonEnabled = (isuseradmin || projectAccess) && (subscriptionstatus === 'Active');
  const iseditButtonEnabled = 
  (
     isuseradmin &&
     subscriptionstatus === 'Active' &&
     projectData?.project_status !== 'Completed'
   ) || 
  (
      (projectAccess || EditAccess) &&
      subscriptionstatus === 'Active' &&
      projectData?.project_status !== 'Completed'
    );

  return (
    <ThemeProvider theme={getTheme()}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
      {subscriptionstatus === 'Expired' && (
        <Typography variant="body1">
          <h3>Please renew your subscription.</h3>
        </Typography>
      )}
      {/* Render content only if not loading */}
      {!isLoading && (
        <>
          {(subscriptionstatus === 'Active' || subscriptionstatus === 'Expired') ? (
            <div>
              <Box sx={{ marginTop: '-60px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box sx={{ marginLeft: 'auto', marginBottom: '15px' }}>
                    <Tooltip
                      title={
                        iscreateButtonEnabled
                          ? ''
                          : 'You do not have access to create a new project'
                      }
                      placement="top"
                      arrow
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          if (iscreateButtonEnabled) {
                            handleCreateProject();
                          }
                        }}
                        sx={{
                          mr: 1,
                          opacity: iscreateButtonEnabled ? 1 : 0.5
                        }}
                      >
                        Create New
                      </Button>
                    </Tooltip>
                  </Box>
                </Box>
              </Box>

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Stack direction='row' spacing={2}>
                    <Paper sx={{ marginLeft: 10, flex: '3 0 60%' }} elevation={3}>
                      <Box sx={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                        <Box sx={{ mr: 2.5, mt: 6 }}>
                          {/* Empty Box for spacing */}
                        </Box>
                        Items in Progress
                      </Box>

                      <BarChart
                        xAxis={[{ scaleType: 'band', data: modulesName }]}
                        series={[
                          { data: modulesCount, color: theme.palette.primary.main },
                        ]}
                        width={700}
                        height={300}
                      />
                    </Paper>

                    <Paper sx={{ flex: '1 0 30%' }} elevation={3}>
                      <Grid
                        container
                        alignItems='center'
                        justifyContent='space-between'
                      >
                        <Grid item>
                          <Box sx={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                            <Box sx={{ mr: 2.5, mt: 6 }}>
                              {/* Empty Box for spacing */}
                            </Box>
                            Project Details
                          </Box>
                        </Grid>
                        <Grid item>
                          {/* <Tooltip
                            title={
                              iseditButtonEnabled
                                ? ''
                                : 'You do not have access to edit this project'
                            }
                            placement="top"
                            arrow
                          > */}
                            <span>
                              {selProjectId !== 0 &&  iseditButtonEnabled ?(
                                <IconButton
                                size='small'
                                color='primary'
                                onClick={handleEditProject}
                              >
                                <EditIcon
                                  fontSize='small'
                                  color='primary'
                                  sx={{ mr: 1 }}
                                />
                              </IconButton>
                            ) : (
                              <div></div>
                            )}
                            </span>
                          
                        </Grid>
                      </Grid>

                      <div>
                        <ul>
                          <div>
                            {selProjectId === 0 ? (
                              <div>
                                {projectStatus?.map((project1, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                    }}
                                  >
                                    <Grid mt={1} container spacing={2}>
                                      <Grid item md={6} xs={12} >
                                        {project1.project_status.project_status} ({' '}
                                        {project1.project_status.count} )
                                      </Grid>
                                      <Grid item md={3} xs={12} style={{ marginLeft: '50px' }}>
                                        {(
                                          (project1.project_status.count /
                                            projectCount) * 100).toFixed(0)}{' '}  %
                                      </Grid>
                                    </Grid>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div>
                                <div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                    }}
                                  >
                                    <p> Project Manager </p>
                                    <p>{projectData?.project_manager} </p>
                                    <p> </p>
                                  </div>

                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                    }}
                                  >
                                    <p> Status </p>
                                    <p>{projectData?.project_status} </p>
                                    <p> </p>
                                  </div>

                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                    }}
                                  >
                                    <p> Start Date </p>
                                    <p>{projectData?.project_start_date} </p>
                                    <p> </p>
                                  </div>

                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                    }}
                                  >
                                    <p> End date </p>
                                    <p>{projectData?.project_end_date} </p>
                                    <p> </p>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </ul>
                      </div>
                    </Paper>
                  </Stack>
                  {/* </Paper> */}
                </Grid>

                <Grid item xs={12}>
                  <Paper style={{ height: '40vh', overflowY: 'scroll' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                      <Box sx={{ mr: 2.5, mt: 6 }}>
                        {/* Empty Box for spacing */}
                      </Box>
                      This Week's Tasks
                    </Box>

                    <ProjectWeeklyTasks project_id={selProjectId} orgid={orgid} ></ProjectWeeklyTasks>
                  </Paper>
                </Grid>
              </Grid>
              <FloatingButton />
            </div>
          ) : (
            <Typography variant="body1">
              <h3>Please purchase a subscription plan.</h3>
            </Typography>
          )}
        </>
      )}
    </ThemeProvider>
  );
};
export default ProjectManagementPage;